import { store } from "@app/store";
import { Button } from "@components/button";
import { Input } from "@components/input";
import { Modal } from "@components/modal";
import { CustomSelect } from "@components/select";
import { useAdminBanks } from "@features/admin/banks";
import { RegexForm } from "@features/admin/banks/api";
import { updateRegexes } from "@features/admin/banks/slice";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

type Props = {
  isModalOpen: boolean;
  hideModal: () => void;
};

const regexTypeOptions = [
  { text: "SMS", value: "sms" },
  { text: "PUSH", value: "push" },
  // { text: "PUSH SBP", value: "push_sbp" },
  // { text: "SMS SBP", value: "sms_sbp" },
];

export const RegexModal = ({ hideModal, isModalOpen }: Props) => {
  const { state } = useAdminBanks();
  const { control, handleSubmit, reset, setValue } = useForm<RegexForm>({
    defaultValues: {
      method: "",
      regex: "",
      description:"",
      type: "",
    }
  });

  const onsubmit = (data: RegexForm) => {
    if (data.id == null || data.id.length == 0) {
      data.id = new Date().toISOString();
    }
    store.dispatch(updateRegexes(data));
    hideModal();
  };

  useEffect(() => {
    if (state.selectedRegex) {
      reset({
        type: state.selectedRegex?.type,
        method: state.selectedRegex?.method,
        regex: state.selectedRegex?.regex,
        description: state.selectedRegex?.description,
        id: state.selectedRegex?.id,
      });
    } else {
      setValue("description", "");
      setValue("type", "");
      setValue("method", "");
      setValue("regex", "");
    }
  }, [state.selectedRegex, state.regexes, reset]);

  return (
    <Modal isOpen={isModalOpen} onClose={hideModal} title="Regex">
      <form>
        <CustomSelect
          control={control}
          options={regexTypeOptions}
          name="type"
          label="Тип"
          styles={{ marginBottom: "5px" }}
        ></CustomSelect>
        <Input
          control={control}
          name="method"
          label="Метод"
          style={{ marginBottom: "5px" }}
        ></Input>
        <Input
          control={control}
          name="regex"
          label="Regex"
          style={{ marginBottom: "5px" }}
        ></Input>
        <Input
          control={control}
          name="description"
          label="Описание"
          style={{ marginBottom: "5px" }}
        ></Input>
        <Button onClick={handleSubmit(onsubmit)}>Сохранить</Button>
      </form>
    </Modal>
  );
};
